var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-preview"},[(_vm.inValid)?_c('span',{staticClass:"icon icon-x"}):_vm._e(),_vm._v(" "),(_vm.preview)?_c('img',{attrs:{"src":_vm.preview}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }